<template>
  <div class="employees-list">
    <m-table-settings
      v-model="tableSettingsModal"
      :columns="tableData.columns"
      :disabled-columns="tableData.disabledColumns"
      :default-disabled-columns="tableData.defaultDisabledColumns"
      with-categories
      @submit="submitTableSettings"
    />

    <div class="employees-list__wrapper">
      <div class="employees-list__actions">
        <div class="employees-list__actions-item">
          <c-button
            responsive
            :disabled="isLoadingTable || tableData.activeFilteredColumns.length === 0"
            label="Сбросить фильтры столбцов"
            :icon="{ color: 'pink', icon: 'filter-drop' }"
            type="with-icon"
            @click="resetColumnFilters"
          />
        </div>

        <div class="employees-list__actions-item">
          <c-button
            responsive
            label="Настроить столбцы"
            icon="cog"
            type="with-icon"
            @click="tableSettingsModal = true"
          />
        </div>
      </div>

      <div v-if="!isLoadingTable" class="employees-list__table">
        <c-data-table
          ref="table"
          class="employees-list-table"
          :levels="isAllowedToWorkerSummaryData ? 3 : 2"
          :sorted-column="tableData.sortedColumn"
          :disabled-columns="tableData.disabledColumns"
          :filtered-columns="tableData.filteredColumns"
          :enabled-fields="enabledFields"
          :active-filtered-columns="tableData.activeFilteredColumns"
          :data="tableData"
          :reference-list="referenceFilterList"
          :empty-records-label="'Сотрудники не найдены'"
          @sortedEvent="refreshTable"
          @getReferenceValues="setColumnReferenceFilterList"
          @reset-column-filters="tableData.activeFilteredColumns = []"
          @remove-column-filter="onColumnFilterRemove"
          @set-column-filter="onSetColumnFilter"
          @set-column-filter-by-index="onSetColumnFilterByIndex"
          @disable-column-sorted-flag="onDisableColumnSortedFlag"
          @change-sorting-column="onSortingColumnChange"
          @edit-worker="$emit('edit-worker', $event)"
        />
        <c-loader v-if="isLoadingData" label="Загрузка данных" :active="isLoadingData" height="150" />
        <transition name="fade">
          <ItemsCount
            :shown-items-count="recordsCount"
            :total-items-count="getTotalRecordsCount"
          />
        </transition>
        <top-button root=".layout"></top-button>

      </div>
      <c-loader v-if="isLoadingTable" label="Загрузка списка сотрудников" :active="isLoadingTable" height="500" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Button from "@/components/controls/button";
import DataTable from "@/components/data-table";
import Loader from "@/components/loader";
import ItemsCount from "@/components/display-shown-items-count.vue";

import TableSettingsModal from "@/components/modals/table-settings";
import { prettifyAmount } from "../../helpers/workWithNumbers";

import { getFiltersFromQuery, transformFiltersToQuery } from "./utils/formatFilters";
import TopButton from "@/components/top-button.vue";

export default {
  name: "employees-list",

  components: {
    TopButton,
    "c-button": Button,
    "c-data-table": DataTable,
    "c-loader": Loader,
    "m-table-settings": TableSettingsModal,
    ItemsCount,
  },

  props: ["enabledFields", "enabledFilters"],

  data() {
    return {
      tableSettingsModal: false,
      page: 1,
      isLoadingTable: false,
      isLoadingData: false,
      isLoadDataOnScroll: true,
      referenceFilterList: [],
      isDisabledScrollDataLoading: false,
      summaryRecord: {
        id: "summary_record",
        isShowRow: true,
      },
      tableData: {
        columns: [],
        userColumns: [],
        actions: true,
        records: [],
        sortedColumn: {
          sortBy: this.$route.query.sortBy ? this.$route.query.sortBy : "created",
          sortType: this.$route.query.sortType ? this.$route.query.sortType : "desc",
        },
        defaultDisabledColumns: ["bonusAndPenalties", "fouls", "bonuses", "penalties"],
        filteredColumns: [],
        type: "employees",
        disabledColumns: [],
        settingsModal: false,
        activeFilteredColumns: [],
        globalFilters: [],
        activeFilteredColumnsQueryLocal: null,
        globalFiltersQueryLocal: null,
      },
      summaryColumns: [],
    };
  },

  computed: {
    ...mapGetters("employees", [
      "getAllFilters",
      "getColumns",
      "getUserColumns",
      "getRecords",
      "getReferenceValues",
      "getUserFilters",
      "isAllowedToWorkerSummaryData",
      "getTotalRecordsCount",
    ]),
    recordsCount () {
      return Math.max(this.tableData.records.length - 1, 0);
    },
    isSummaryColumnInUserColumns() {
      let exists = false;
      this.summaryColumns.forEach((column) => {
        if (exists) {
          return;
        }
        if (this.getUserColumns.includes(column)) {
          exists = true;
        }
      });

      return exists;
    },
  },

  watch: {
    
    "isAllowedToWorkerSummaryData": function (value) {
      return; // .dispatch("employees/getRecords")

      if (value) {
        this.$store.dispatch("employees/getSummaryData", [
          {
            localFilters: [...this.tableData.activeFilteredColumns],
            globalFilters: [...this.tableData.globalFilters],
          },
        ]).then(({ data }) => {
          Object.entries(data).forEach(([key, value]) => {
            this.summaryRecord[key] = {
              value: prettifyAmount(value, 0).split(" ").join("\u00A0"),
            };
            this.summaryColumns.push(key);
          });
        });
      }
    },
    "getColumns": function (value) {
      this.tableData.filteredColumns = [];

      this.tableData.columns = value.map((item) => {
        if (item.data_type !== null) {
          this.tableData.filteredColumns.push(item.code);
          if (this.$route.query[item.code] !== undefined) {
            let filterOptions;

            if (this.$route.query[`${item.code}_filterType`] === "list") {
              const values = this.$route.query[item.code].split(",").map((item) => ({ id: item }));
              filterOptions = {
                id: item.code,
                type: this.$route.query[`${item.code}_filterType`],
                searchType: this.$route.query[`${item.code}_searchType`],
                value: values,
              };
            } else if (
              this.$route.query[`${item.code}_filterType`] === "number" &&
              this.$route.query[`${item.code}_searchType`] === "4"
            ) {
              const values = this.$route.query[item.code].split(",");
              const rangeVal = { start: values[0], end: values[1] };
              filterOptions = {
                id: item.code,
                type: this.$route.query[`${item.code}_filterType`],
                searchType: this.$route.query[`${item.code}_searchType`],
                value: rangeVal,
              };
            } else {
              filterOptions = {
                id: item.code,
                type: this.$route.query[`${item.code}_filterType`],
                searchType: this.$route.query[`${item.code}_searchType`],
                value: this.$route.query[item.code],
              };
            }
            this.tableData.activeFilteredColumns.push(filterOptions);
          }
        }

        const unit = item.unit === "ruble" ? ", ฿" : "";

        return {
          id: item.code,
          label: item.short_name + unit,
          unit: item.unit,
          fullName: item.name + unit,
          type: item.data_type ? item.data_type : undefined,
          description: item.description ? item.description : undefined,
          parentColumnId: item.parent_column ? item.parent_column : undefined,
          level: item.level,
          isCategory: item.is_category,
          characteristic: item.characteristic,
          isSorted: item.code === this.tableData.sortedColumn.sortBy,
        };
      });

      const sortingArr = [
        "personalData",
        "filial",
        "company",
        "fullName",
        "postCategorySpecialty",
        "category",
        "schedule",
        "workerStatus",
        "dismissalReason",
        "employmentStatus",
        "characteristic",
        "citizenship",
        "lawStatus",
        "hiringDate",
        "hiringDate2",
        "workDuration",
        "phone",
        "address",
        "statusChangeDate",
        "dismissalDate",
        "dismissalDate2",
        "finance",
        "depositStatus",
        "deposit",
        "personalAccount",
        "premiumAccount",
        "bonusAndPenalties",
        "fouls",
        "penalties",
        "bonuses",
      ];

      this.tableData.columns.sort((a, b) => sortingArr.indexOf(a.id) - sortingArr.indexOf(b.id));
    },

    "getUserColumns": function (value) {
      if (value !== undefined) {
        const disabledColumns = this.getColumns.filter((item) => !value.includes(item.code));

        this.tableData.disabledColumns = disabledColumns.map((item) => item.code);
        this.tableData.userColumns = value;
      }
    },

    "getRecords": function (value) {
      if (value === "isExportExcel") return;

      const depositColorsMap = {
        "Без депозита": "none",
        "Не внесён": "error",
        "Внесён частично": "error",
        "Выплачен излишне": "error",
        "Внесён": "success",
        "Внесён излишне": "warning",
      };

      if ((value === undefined || (Array.isArray(value) && value.length === 0)) && this.page === 1) {
        this.tableData.records = [];
        this.isDisabledScrollDataLoading = true;
        return;
      }

      if ((value === undefined || (Array.isArray(value) && value.length === 0)) && this.page !== 1) {
        this.isDisabledScrollDataLoading = true;
        return;
      }

      const currentPageRecords = value.map((item) => {
        let rankStatus = "";
        if (item.rank_info && item.rank_info.action) {
          rankStatus = item.rank_info.action === "raise" ? "up" : "down";
        }

        return {
          id: item.workerId,
          canBeEdited: item.canEditFilial,
          filial: {
            value: item.filial,
          },
          company: {
            value: item.company,
          },
          fullName: {
            value: item.fullName,
            employee: {
              rankStatus,
              rankValue: item.rank_info && item.rank_info.value ? item.rank_info.value : undefined,
              docsTrouble: item.docs_status,
              id: item.workerId,
              fullName: item.fullName,
            },
          },
          postCategorySpecialty: {
            value: item.postCategorySpecialty ? Object.values(item.postCategorySpecialty).join("\n") : undefined,
          },
          category: {
            value: item.category ? Object.values(item.category).join(", ") : undefined,
          },
          schedule: {
            value: item.schedule,
          },
          characteristic: {
            value: item.characteristic,
          },
          lawStatus: {
            value: item.lawStatus,
          },
          workerStatus: {
            value: item.workerStatus,
          },
          citizenship: {
            value: item.citizenship,
          },
          personalAccount: {
            value: item.personalAccount,
          },
          premiumAccount: {
            value: item.premiumAccount,
          },
          fouls: {
            value: item.fouls,
          },
          bonuses: {
            value: item.bonuses,
          },
          penalties: {
            value: item.penalties,
          },
          employmentStatus: {
            value: item.employmentStatus,
          },
          depositStatus: {
            value: item.depositStatus,
            depositState: {
              color: depositColorsMap[item.depositStatus],
              text: item.depositStatus,
            },
          },
          deposit: {
            value: item.deposit,
          },
          created: {
            value: item.created,
          },
          _meta: {
            worksheet: item.quest_info,
          },
          hiringDate: {
            value: item.hiringDate,
          },
          dismissalDate: {
            value: item.dismissalDate,
          },
          hiringDate2: {
            value: item.hiringDate2,
          },
          dismissalDate2: {
            value: item.dismissalDate2,
          },
          workDuration: {
            value: item.workDuration,
          },
          statusChangeDate: {
            value: item.statusChangeDate,
          },
          phone: {
            value: item.phone,
          },
          address: {
            value: item.address,
          },
          dismissalReason: {
            value: item.dismissalReason,
          },
          isShowRow: true,
        };
      });

      if ((currentPageRecords && currentPageRecords.length < 30) || (Array.isArray(value) && value.length < 30)) {
        this.isDisabledScrollDataLoading = true;
      }

      if (this.page === 1) {
        this.tableData.records = currentPageRecords;

        // if (this.isAllowedToWorkerSummaryData && this.isSummaryColumnInUserColumns) {
        this.tableData.records.unshift(this.summaryRecord);
        // }
      } else {
        this.tableData.records = this.tableData.records.concat(currentPageRecords);
      }
    },

    "tableData.activeFilteredColumns": function (value) {
      if (!this.isLoadingTable) {
        const queryFilters = transformFiltersToQuery(value);

        this.tableData.activeFilteredColumnsQueryLocal = queryFilters;

        const fullQuery = {
          sortBy: this.tableData.sortedColumn.sortBy,
          sortType: this.tableData.sortedColumn.sortType,
          ...queryFilters,
          ...this.tableData.globalFiltersQueryLocal,
        };

        if (JSON.stringify(this.$route.query) !== JSON.stringify(fullQuery)) {
          this.isLoadingTable = true;
          this.isLoadingData = true;
          this.isDisabledScrollDataLoading = true;
          this.page = 1;
          this.$emit("update");
          this.$store
            .dispatch("employees/getRecords", [
              this.page,
              this.tableData.sortedColumn.sortBy,
              this.tableData.sortedColumn.sortType,
              {
                localFilters: [...value],
                globalFilters: [...this.tableData.globalFilters],
              },
            ])
            .then((result) => {
              if (result.workers !== undefined && result.workers.length === 30) {
                this.isDisabledScrollDataLoading = false;
              }
              this.getSummary();
            })
            .finally(() =>
              setTimeout(() => {
                this.$router
                  .replace({
                    name: "employees-list",
                    query: fullQuery,
                  })
                  .catch(() => {});

                this.isLoadingTable = false;
                this.isLoadingData = false;
              }, 300),
            );
        }
      }
    },

    "enabledFilters": function (value) {
      const activeGlobalFilters = [];

      value.forEach((item) => {
        const c = activeGlobalFilters.findIndex((i) => i.id === item.id);

        if (c === -1 && item.type === "number" && item.searchType === "4" && item.value.end !== 0) {
          activeGlobalFilters.push(item);
        }

        if (c !== -1 && item.type === "number" && item.searchType === "4" && item.value.end !== 0) {
          activeGlobalFilters[c] = item;
        }

        if (c === -1 && item.type === "boolean" && item.value) {
          activeGlobalFilters.push(item);
        }

        if (c !== -1 && item.type === "boolean") {
          if (item.value.toString() === "1") {
            activeGlobalFilters[c] = item;
          }
          if (item.value.toString() === "0") {
            activeGlobalFilters.splice(c, 1);
          }
        }

        if (c !== -1 && item.value.length === 0 && item.type !== "boolean") {
          activeGlobalFilters.splice(c, 1);
        } else if (c !== -1 && item.value.length > 0 && item.type !== "boolean") {
          activeGlobalFilters[c] = item;
        } else if (c === -1 && item.value.length > 0 && item.type !== "boolean") {
          activeGlobalFilters.push(item);
        }
      });

      this.tableData.globalFilters = [...activeGlobalFilters];
    },

    "tableData.globalFilters": function (value) {
      if (!this.isLoadingTable) {
        const queryFilters = value.reduce((acc, item) => {
          let currentFilter;
          if (item.type === "list") {
            currentFilter = {
              [item.id]: item.value.map((i) => i.id).join(","),
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "number" && item.searchType === "4") {
            currentFilter = {
              [item.id]: `${item.value.start},${item.value.end}`,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          } else if (item.type === "boolean") {
            if (item.value === "1") {
              currentFilter = {
                [item.id]: item.value,
                [`${item.id}_filterType`]: item.type,
              };
            }
          } else {
            currentFilter = {
              [item.id]: item.value,
              [`${item.id}_filterType`]: item.type,
              [`${item.id}_searchType`]: item.searchType,
            };
          }
          return { ...acc, ...currentFilter };
        }, {});

        this.tableData.globalFiltersQueryLocal = queryFilters;

        this.$emit("setTabsQuery", queryFilters);

        const fullQuery = {
          sortBy: this.tableData.sortedColumn.sortBy,
          sortType: this.tableData.sortedColumn.sortType,
          ...queryFilters,
          ...this.tableData.activeFilteredColumnsQueryLocal,
        };

        if (JSON.stringify(this.$route.query) !== JSON.stringify(fullQuery)) {
          this.isLoadingTable = true;
          this.isLoadingData = true;
          this.isDisabledScrollDataLoading = true;
          this.page = 1;
          this.$emit("update");
          this.$store
            .dispatch("employees/getRecords", [
              this.page,
              this.tableData.sortedColumn.sortBy,
              this.tableData.sortedColumn.sortType,
              {
                globalFilters: [...value],
                localFilters: [...this.tableData.activeFilteredColumns],
              },
            ])
            .then((result) => {
              if (result.workers !== undefined && result.workers.length === 30) {
                this.isDisabledScrollDataLoading = false;
              }
              this.getSummary();
            })
            .finally(() =>
              setTimeout(() => {
                this.$router
                  .replace({
                    name: "employees-list",
                    query: fullQuery,
                  })
                  .catch(() => {});

                this.isLoadingTable = false;
                this.isLoadingData = false;
              }, 300),
            );
        }
      }
    },
  },

  mounted() {
    document.querySelector(".layout").addEventListener("scroll", this.loadMoreRecords);
  },

  async created() {
    this.isLoadingTable = true;
    await this.$store.dispatch("employees/getColumns").then(() =>
      this.$store.dispatch("employees/getUserColumns").then(() =>
        this.$store.dispatch("employees/getAllFilters").then((res) => {
          const filters = getFiltersFromQuery(res, this.$route.query);
          this.tableData.globalFilters = [...this.tableData.globalFilters, ...filters];
          this.$emit("ready");
          this.$emit("update");
          this.$store
            .dispatch("employees/getRecords", [
              this.page,
              this.tableData.sortedColumn.sortBy,
              this.tableData.sortedColumn.sortType,
              {
                localFilters: [...this.tableData.activeFilteredColumns],
                globalFilters: [...this.tableData.globalFilters],
              },
            ])
            .then(() => {
              this.tableData.activeFilteredColumnsQueryLocal = this.tableData.activeFilteredColumns.reduce(
                (acc, item) => {
                  let currentFilter;
                  if (item.type === "list") {
                    currentFilter = {
                      [item.id]: item.value.map((i) => i.id).join(","),
                      [`${item.id}_filterType`]: item.type,
                      [`${item.id}_searchType`]: item.searchType,
                    };
                  } else if (item.type === "number" && item.searchType === "4") {
                    currentFilter = {
                      [item.id]: `${item.value.start},${item.value.end}`,
                      [`${item.id}_filterType`]: item.type,
                      [`${item.id}_searchType`]: item.searchType,
                    };
                  } else if (item.type === "boolean") {
                    currentFilter = {
                      [item.id]: item.value,
                      [`${item.id}_filterType`]: item.type,
                    };
                  } else {
                    currentFilter = {
                      [item.id]: item.value,
                      [`${item.id}_filterType`]: item.type,
                      [`${item.id}_searchType`]: item.searchType,
                    };
                  }
                  return { ...acc, ...currentFilter };
                },
                {},
              );

              this.tableData.globalFiltersQueryLocal = this.tableData.globalFilters.reduce((acc, item) => {
                let currentFilter;
                if (item.type === "list") {
                  currentFilter = {
                    [item.id]: item.value.map((i) => i.id).join(","),
                    [`${item.id}_filterType`]: item.type,
                    [`${item.id}_searchType`]: item.searchType,
                  };
                } else if (item.type === "number" && item.searchType === "4") {
                  currentFilter = {
                    [item.id]: `${item.value.start},${item.value.end}`,
                    [`${item.id}_filterType`]: item.type,
                    [`${item.id}_searchType`]: item.searchType,
                  };
                } else if (item.type === "boolean") {
                  if (item.value === "1") {
                    currentFilter = {
                      [item.id]: item.value,
                      [`${item.id}_filterType`]: item.type,
                    };
                  }
                } else {
                  currentFilter = {
                    [item.id]: item.value,
                    [`${item.id}_filterType`]: item.type,
                    [`${item.id}_searchType`]: item.searchType,
                  };
                }
                return { ...acc, ...currentFilter };
              }, {});

              setTimeout(() => {
                this.$emit("globalFiltersActive");
              }, 400);

              this.getSummary();
              this.isLoadingTable = false;
            });
        }),
      ),
    );
  },

  methods: {
    getSummary() {
      console.log("!!!!");
      // if (value) {
      this.$store.dispatch("employees/getSummaryData", [
        {
          localFilters: [...this.tableData.activeFilteredColumns],
          globalFilters: [...this.tableData.globalFilters],
        },
      ]).then(({ data }) => {
        Object.entries(data).forEach(([key, value]) => {
          this.summaryRecord[key] = {
            value: prettifyAmount(value, 0).split(" ").join("\u00A0"),
          };
          this.summaryColumns.push(key);
        });
      });
      // }      
    },

    onColumnFilterRemove(columnIndex) {
      this.tableData.activeFilteredColumns.splice(columnIndex, 1);
    },
    onSetColumnFilter(filterOptions) {
      this.tableData.activeFilteredColumns.push(filterOptions);
    },
    onSetColumnFilterByIndex(columnIndex, filterOptions) {
      this.tableData.activeFilteredColumns[columnIndex] = filterOptions;
    },
    onDisableColumnSortedFlag(columnIndex) {
      this.tableData.columns[columnIndex].isSorted = false;
    },

    onSortingColumnChange(sortingData) {
      this.tableData.sortedColumn = sortingData;
    },
    refreshTable(e) {
      if (!this.isLoadingTable) {
        this.isLoadingTable = true;
        this.isDisabledScrollDataLoading = true;
        this.page = 1;
        this.$emit("update");
        this.$store
          .dispatch("employees/getRecords", [
            this.page,
            e.sortBy,
            e.sortType,
            {
              localFilters: [...this.tableData.activeFilteredColumns],
              globalFilters: [...this.tableData.globalFilters],
            },
          ])
          .then((res) => {
            this.isLoadingTable = false;
            if (res.workers !== undefined && res.workers.length === 30) {
              this.isDisabledScrollDataLoading = false;
            }
            const currentQuery = JSON.parse(JSON.stringify(this.$route.query));
            currentQuery.sortBy = this.tableData.sortedColumn.sortBy;
            currentQuery.sortType = this.tableData.sortedColumn.sortType;
            this.getSummary();
            this.$router
              .replace({
                name: "employees-list",
                query: currentQuery,
              })
              .catch(() => {});
          });
      }
    },

    submitTableSettings(disabledColumns) {
      let enabledColumns = this.getColumns.filter((item) => !disabledColumns.includes(item.code));

      enabledColumns = enabledColumns.map((item) => item.code);

      this.$refs.table.$refs.wrapper.update();

      setTimeout(() => {
        if (this.$refs.table) {
          const isScroll =
            this.$refs.table.$refs.wrapper.$el.clientWidth < this.$refs.table.$refs.wrapper.$el.scrollWidth;
          this.$refs.table._data.isScroll = isScroll;
        }
      }, 1500);

      this.isLoadingTable = true;
      this.$store.dispatch("employees/saveUserColumns", enabledColumns).then((res) => {
        this.isLoadingTable = false;
        const filterActiveFilteredColumns = this.tableData.activeFilteredColumns.filter((filter) =>
          res.includes(filter.id),
        );

        if (JSON.stringify(this.tableData.activeFilteredColumns) !== JSON.stringify(filterActiveFilteredColumns)) {
          this.tableData.activeFilteredColumns = [...filterActiveFilteredColumns];
        } else {
          this.refreshTable({
            sortBy: this.tableData.sortedColumn.sortBy,
            sortType: this.tableData.sortedColumn.sortType,
          });
        }
      });
    },

    resetColumnFilters() {
      this.tableData.activeFilteredColumns = [];
      // this.$refs.table.resetColumnFilters()
    },

    loadMoreRecords() {
      const layout = document.querySelector(".layout");
      const isScrollable = layout.scrollHeight > layout.clientHeight;

      const scroll = Math.round(layout.scrollTop);
      const height = layout.scrollHeight - layout.clientHeight;

      if (
        isScrollable &&
        scroll === height &&
        !this.isLoadingData &&
        !this.isDisabledScrollDataLoading &&
        !this.isLoadingTable
      ) {
        this.isLoadingData = true;
        this.page += 1;
        this.$emit("update");
        this.$store
          .dispatch("employees/getRecords", [
            this.page,
            this.tableData.sortedColumn.sortBy,
            this.tableData.sortedColumn.sortType,
            {
              localFilters: [...this.tableData.activeFilteredColumns],
              globalFilters: [...this.tableData.globalFilters],
            },
          ])
          .finally(() =>
            setTimeout(() => {
              this.isLoadingData = false;
            }, 300),
          );
      }
    },

    setColumnReferenceFilterList(e) {
      const columnId = e.id;

      if (columnId === "dismissalReason") {
        this.$store.dispatch("employees/getDismissReasons").then(({ response }) => {
          this.referenceFilterList = response.map((item) => ({
            id: item.id,
            label: item.description,
            value: item.id,
          }));
        });

        return;
      }

      this.$store.dispatch("employees/getReferenceValues", columnId).then((result) => {
        if (columnId === "category") {
          const mapDischargeValues = [];
          result.data.forEach((item) => {
            const c = mapDischargeValues.findIndex((i) => i.value === item.id);
            if (c === -1)
              mapDischargeValues.push({
                id: item.id,
                value: item.id,
                label: item.value,
              });
          });
          this.referenceFilterList = [...mapDischargeValues];
        } else if (columnId === "company") {
          this.referenceFilterList = Object.entries(result.data).map(([value, label]) => ({ value, label, id: value }));
        } else {
          this.referenceFilterList = result.data.map((item) => {
            if (item.id !== undefined) {
              return { id: item.id, value: item.id, label: item.name };
            }
            return { id: item.code, value: item.code, label: item.name };
          });
          // Добавляем справочное значение "Не указано", т.к не приходит с бекенда
          if (e.id === "citizenship") {
            this.referenceFilterList.push({
              id: "undefined",
              value: "undefined",
              label: "Не указано",
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.employees-list {
  &__wrapper {
    position: relative;

    ::v-deep .c-table__wrapper > .ps__rail-x {
      z-index: 351;
      background: #ffffff !important;
    }

    ::v-deep .c-table__wrapper > .ps__rail-x:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-30px, 0);
      box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
      z-index: -1;
      height: 24px;
      width: calc(100vw - 60px);
      background: #ffffff;
    }

    ::v-deep .c-table__wrapper > .ps__rail-x:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0, calc(-50% + 1px));
      border-radius: 10px;
      z-index: -1;
      height: 4px;
      width: calc(100% - 34px);
      background: #dfe4ef;
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;

    &-item {
      margin-left: 10px;
      margin-bottom: 23px;
    }
  }

  &__table {
    /*margin-top: 23px;*/
  }
}
::v-deep .c-table-cell.c-table__cell-cell {
  display: flex;
}
::v-deep .c-table-cell__wrapper.cell-employee {
  flex-grow: 1;
}
::v-deep .c-table__shadow {
  height: calc(100% - 19px);
}
</style>
